import {useEffect, useState} from "react";


const NumberInput = ({initNumber, onChangedNumber}) => {
    const [number, setNumber] = useState(initNumber ?? "")

    useEffect(() => {
        onChangedNumber(number)
    }, [number])

    return (
        /*
          `flex` 는 명시용이다 — 동작은 종전과 같다 (2026-08-26 추가 / 2026-08-27 정정)

          🔴 **정정**: 처음에는 "`flex` 가 없어서 이 div 가 블록이고, 자식 `.popup-number` 4개가
             각각 `height: 100%` 이라 400% 로 쌓여 1행만 보인다" 고 적었다. **이 저장소에서는 틀렸다.**
             `src/App.js:9` 가 `omoplay/dist/style.scss` 를 import 하고 그 파일이
             `.flex-col { display:flex; flex-direction:column }` 으로 **Tailwind 유틸리티를 재정의**한다.
             ⇒ `flex-col` 만으로도 이미 flex 컨테이너였고, 4행은 `flex-shrink` 로 나눠 가져
             **정상 렌더되고 있었다.**

          그래서 이 `flex` 는 버그 수정이 아니라 **의도를 코드에 드러내는 것**이다
          (CSS 로드 순서나 `style.scss` import 가 사라져도 깨지지 않는다).

          ⚠️ 순수 Tailwind 기준에서는 여전히 `flex-col` 만으로는 블록이다.
             `headless-redirect-service` 의 `static/front`(고객 화면)는 omoplay 를 로드하지 않으므로
             거기서는 반드시 `flex` 를 함께 써야 한다. **두 저장소의 전제가 다르다.**
        */
        <div className="w-full h-full flex flex-col bg-white">
            <div className="popup-number">
                <div onClick={() => setNumber(number + "1")}>1</div>
                <div onClick={() => setNumber(number + "2")}>2</div>
                <div onClick={() => setNumber(number + "3")}>3</div>
            </div>
            <div className="popup-number">
                <div onClick={() => setNumber(number + "4")}>4</div>
                <div onClick={() => setNumber(number + "5")}>5</div>
                <div onClick={() => setNumber(number + "6")}>6</div>
            </div>
            <div className="popup-number">
                <div onClick={() => setNumber(number + "7")}>7</div>
                <div onClick={() => setNumber(number + "8")}>8</div>
                <div onClick={() => setNumber(number + "9")}>9</div>
            </div>
            <div className="popup-number">
                <div onClick={() => setNumber(number + "000")}>000</div>
                <div onClick={() => setNumber(number + "0")}>0</div>
                <div onClick={() => setNumber(number.substring(0, number.length - 1))}>{"←"}</div>
            </div>
            {/*<div onClick={() => setNumber(initNumber ?? "")}>C</div>*/}
        </div>
    )
}

export default NumberInput